package ai.jessie.shared.projects

import kotlinx.serialization.Serializable

// UC-010 / FR-010. IDs are public UUIDs; amounts are exact decimal strings.
@Serializable
data class PositionInput(
    val name: String,
    val type: String,
    val billable: Boolean,
    val active: Boolean = true,
    val unitPrice: String? = null,
    val vatRateId: String? = null,
    val id: String? = null,
)

@Serializable
data class SaveProjectRequest(
    val name: String,
    val billable: Boolean,
    val positions: List<PositionInput>,
    val description: String? = null,
    val customerId: String? = null,
    val active: Boolean = true,
    val expectedUpdatedAt: String? = null,
    val confirmed: Boolean = false,
)

@Serializable
data class ProjectStateRequest(val expectedUpdatedAt: String, val confirmed: Boolean = false)

@Serializable
data class ProjectResponse(
    val id: String,
    val name: String,
    val description: String?,
    val customerId: String?,
    val customerName: String?,
    val billable: Boolean,
    val active: Boolean,
    val positions: List<PositionResponse>,
    val referenced: Boolean,
    val createdAt: String,
    val updatedAt: String,
)

@Serializable
data class PositionResponse(
    val details: PositionInput,
    val vatName: String?,
    val vatRate: String?,
    val referenced: Boolean,
    val createdAt: String,
    val updatedAt: String,
)

@Serializable data class ProjectCustomerOption(val id: String, val name: String)

@Serializable
data class ProjectVatOption(
    val id: String,
    val name: String,
    val rate: String,
    val effectiveFrom: String,
    val effectiveTo: String?,
)

@Serializable
data class ProjectSelectionsResponse(
    val currentDate: String,
    val customers: List<ProjectCustomerOption>,
    val vatRates: List<ProjectVatOption>,
)

@Serializable data class ProjectActivityResponse(val workEntries: Long, val durationSeconds: Long)

@Serializable data class ProjectFieldProblem(val field: String, val reason: String)

@Serializable
data class ProjectProblemResponse(
    val code: String,
    val problems: List<ProjectFieldProblem> = emptyList(),
)
